angular.module('impactx.toast').controller('UploadToastCtrl', [
    '$scope',
    'ToastService',
    '$mdToast',
    '$timeout',
    '$workspace',
    'TranslationService',
    'dataGen',
    UploadToastController]);

function UploadToastController($scope, ToastService, $mdToast, $timeout, $workspace, TranslationService, dataGen) {
    $scope.theme = $workspace.getCurrentWorkspaceId().value;
    $scope.textMessage = TranslationService.get('uploadInProgress');

    $scope.$watch(function () {
        return ToastService.getUploadProgress();
    }, function (newValue) {
        if (newValue) {
            $scope.progress = newValue;
            if ($scope.progress >= 100) {
                $scope.textMessage = TranslationService.get('uploadSuccessful');
                $timeout(function () {
                    $mdToast.hide();
                }, 3000);
            }

            if ($scope.progress == -1) {
                $scope.aborted = true;
                $scope.textMessage = TranslationService.get('uploadFailed');
            }
        }
    });

    $scope.cancelUpload = function () {
        if ($scope.progress >= 100 || $scope.aborted) {
            $mdToast.hide();
        }
        else {
            $scope.textMessage = TranslationService.get('uploadAborted');
            $scope.aborted = true;
            dataGen.cancelUpload();
            $timeout(function () {
                $mdToast.hide("aborted");
            }, 3000);
        }
    }
}